import { render, staticRenderFns } from "./columnar.vue?vue&type=template&id=33d6a672"
import script from "./columnar.vue?vue&type=script&lang=js"
export * from "./columnar.vue?vue&type=script&lang=js"
import style0 from "./columnar.vue?vue&type=style&index=0&id=33d6a672&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports